export const API_BASE_URLS = {
  PRODUCTION: 'https://api.myhomey.ai',
  // STAGING: 'https://81f1c88f93e3.ngrok-free.app',
  STAGING: 'http://localhost:5001',
} as const;

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/v1/auth/register',
    LOGIN: '/v1/auth/login',
    LOGOUT: '/v1/auth/logout',
    REFRESH: '/v1/auth/refresh',
    PROFILE: '/v1/auth/profile',
    FORGOT_PASSWORD: '/v1/auth/forgot-password',
    RESET_PASSWORD: '/v1/auth/reset-password',
  },
  FUB: {
    LEADS: '/v1/leads',         // leads list from FUB-a
    LEAD: (id: string | number) => `/v1/leads/${id}`, // single lead details
    CONVERSATIONS: (id: string | number) => `/v1/leads/${id}/conversations`, // chat for lead
    CREATE_NOTE: (id: string | number) => `/v1/leads/${id}/notes`, // lead notes
    NEXT_ACTION: (id: string | number) => `/v1/leads/${id}/next-action`, // AI or workflow next action suggestion
  },
  PAYMENTS: {
    CUSTOMER_PORTAL: '/v1/payments/customer-portal',
    CUSTOMERS: '/v1/payments/customers',
    SUBSCRIPTIONS: '/v1/payments/subscriptions',
  },
  // Added calendar endpoints
  CALENDAR: {
    AVAILABILITY: '/v1/calendar/availability',
    AUTH_URL: '/v1/calendar/connection/authorize',
    COMPLETE_AUTH: '/v1/calendar/connection/complete',
    DISCONNECT: '/v1/calendar/connection',
    STATUS: '/v1/calendar/connection/status',
  },
  MEETINGS: {
    AVAILABILITY: '/v1/meetings/availability',
    SCHEDULE: '/v1/meetings/schedule',
    RESCHEDULE: (eventId: string) => `/v1/meetings/reschedule/${eventId}`,
    CANCEL: (eventId: string) => `/v1/meetings/cancel/${eventId}`,
    DETAILS: (eventId: string) => `/v1/meetings/${eventId}`,
  }
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your internet connection.',
  UNAUTHORIZED: 'Unauthorized access. Please log in to your account.',
  FORBIDDEN: 'Access forbidden.',
  NOT_FOUND: 'Resource not found.',
  INTERNAL_SERVER_ERROR: 'Internal server error.',
  VALIDATION_ERROR: 'Data validation error.',
  DEFAULT: 'An unexpected error occurred.',
} as const; 